import { useChannelConnectionQuery } from '@/features/msg-channels/common/msg-channels.query';
import { MessagingChannelTypes } from '@/features/msg-channels/common/msg-channels.types';

const CHANNEL_TYPE = MessagingChannelTypes.WHATSAPP_BUSINESS;

export function useWhatsAppChannelQuery(options?: {
  enabled?: boolean;
  refetchInterval?: number | false;
}) {
  return useChannelConnectionQuery(CHANNEL_TYPE, options);
}
